import Instance from '../../../../Axios';

// New Actions for the app

const GetObrasEquipamentos = () => async (dispatch) => {
  await Instance()
    .get(`/construcoes/obras/all/equipamentos`)
    .then(({ data }) => {
      dispatch({ type: 'GET_OBRAS_EQUIPAMENTOS', payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetObrasEquipamentos;
